export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معروض:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المجموع"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["في الصفحة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عرض"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["النتائج"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["من"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["صفقة"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["صفقات"])}
}